export class NineSliceDictionary
{
  public static readonly values = {
    dialog_bg: "dialog_bg",
    dialog_btn_100x108: "dialog_btn_100x108",
    loading_bar_base: "loading_bar_base",
    loading_bar_fill: "loading_bar_fill",
    capsule_vertical: "capsule_vertical",
    dialog_slot_frame: "dialog_slot_frame",
    tutorial_substrate: "tutorial_substrate",
    one_plus_one_frame_half: "one_plus_one_frame_half",
    play_dialog_bg_half: "play_dialog_bg_half",
  };
}
